export const findImageByTitle = (images, title) =>
  images.find(i => i.title === title);
